import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Add auth token interceptor
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken && accessToken !== 'null' && accessToken !== 'undefined') {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const apiService = {
  get: (url) => api.get(url).then(res => res.data),
  post: (url, data) => api.post(url, data).then(res => res.data),
  put: (url, data) => api.put(url, data).then(res => res.data),
  delete: (url) => api.delete(url).then(res => res.data),
};

const MARKETING_API = '/marketing';

const campaignService = {
  /**
   * Get all campaigns for the current user
   */
  async getCampaigns(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.type) params.append('type', filters.type);
      
      const queryString = params.toString();
      const url = queryString ? `${MARKETING_API}?${queryString}` : MARKETING_API;
      
      const response = await apiService.get(url);
      return response.campaigns || [];
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      throw error;
    }
  },

  /**
   * Get a single campaign by ID
   */
  async getCampaign(campaignId) {
    try {
      const response = await apiService.get(`${MARKETING_API}/${campaignId}`);
      return response;
    } catch (error) {
      console.error('Error fetching campaign:', error);
      throw error;
    }
  },

  /**
   * Create a new campaign
   */
  async createCampaign(campaignData) {
    try {
      const response = await apiService.post(MARKETING_API, campaignData);
      return response;
    } catch (error) {
      console.error('Error creating campaign:', error);
      throw error;
    }
  },

  /**
   * Update an existing campaign
   */
  async updateCampaign(campaignId, campaignData) {
    try {
      const response = await apiService.put(`${MARKETING_API}/${campaignId}`, campaignData);
      return response;
    } catch (error) {
      console.error('Error updating campaign:', error);
      throw error;
    }
  },

  /**
   * Delete a campaign
   */
  async deleteCampaign(campaignId) {
    try {
      const response = await apiService.delete(`${MARKETING_API}/${campaignId}`);
      return response;
    } catch (error) {
      console.error('Error deleting campaign:', error);
      throw error;
    }
  },

  /**
   * Start a campaign (creates jobs)
   */
  async startCampaign(campaignId) {
    try {
      const response = await apiService.post(`${MARKETING_API}/${campaignId}/start`);
      return response;
    } catch (error) {
      console.error('Error starting campaign:', error);
      throw error;
    }
  },

  /**
   * Pause a campaign
   */
  async pauseCampaign(campaignId) {
    try {
      const response = await apiService.post(`${MARKETING_API}/${campaignId}/pause`);
      return response;
    } catch (error) {
      console.error('Error pausing campaign:', error);
      throw error;
    }
  },

  /**
   * Resume a paused campaign
   */
  async resumeCampaign(campaignId) {
    try {
      const response = await apiService.post(`${MARKETING_API}/${campaignId}/resume`);
      return response;
    } catch (error) {
      console.error('Error resuming campaign:', error);
      throw error;
    }
  }
};

export default campaignService;

